export const getPackages = (option) =>
  option && option.publishOptions && Array.isArray(option.publishOptions.servicePackages)
    && option.publishOptions.servicePackages
    || [];

export const getPeriods = (option) =>
  option && option.publishOptions && Array.isArray(option.publishOptions.periods)
    && option.publishOptions.periods
    || [];

// Есть ли у услуги периоды сутки, 7 дней, 14 дней и т.д.
export const hasPeriods = (option) => getPeriods(option).length > 0;

// Есть ли у услуги пакеты объявлений
export const hasPackages = (option) => getPackages(option).length > 0;

// Есть ли у услуги оплаченные пакеты
export const hasPaidPackage = (option) => getPackages(option).findIndex(isOptionElementPaid) !== -1;

// Получить оплаченный пакет
export const getPaidPackage = (option) => getPackages(option).find(isOptionElementPaid);

// Получить дефолтный пакет(первый)
export const getDefaultPackage = (option) => getPackages(option)[0];

// Есть ли оплаченный период
export const hasPaidPeriod = (option) => getPeriods(option).findIndex(isOptionElementPaid) !== -1;

// Получить оплаченный период
export const getPaidPeriod = (option) => getPeriods(option).find(isOptionElementPaid);

// Дефолтным периодом считается посуточное размещение
export const getDefaultPeriod = (option, key = 'DailyTermless-1') => {
  const periods = getPeriods(option);

  return periods.find((period) => period.key === key) || periods[0];
};

// Есть ли оплаченный пакет или период
export const hasPaidPackageOrPeriod = (option) => hasPaidPackage(option) || hasPaidPeriod(option);

// Получаем оплаченный период или пакет
export const getPaidPackageOrPeriod = (option) => getPaidPackage(option) || getPaidPeriod(option);

// Временное условие, возможно стоит ввести более осмысленное свойство в объекте элемента опции
// Определяет чем является selectedPeriod
// Аргумент option это объект массива publishOptions.periods или publishOptions.servicePackages
export const isPackage = (option = {}) => option.servicePackageActualCount !== null;
export const isPeriod = (option) => !isPackage(option);

// Это либо пакет, либо посуточный период
export const isOptionElementDailyTermless = (option) => option.key === 'DailyTermless-1';
// Это оплаченный пакет или период
export const isOptionElementPaid = (option) => option.isPaid;

export const getPrice = (option) =>
  option && option.selectedPeriod
    && option.selectedPeriod.price
    || 0;

export const getPriceBeforeDiscount = (option) =>
  option && option.selectedPeriod
    && option.selectedPeriod.marketingPrice
    || 0;

export const getDiscount = (option) =>
  option && option.selectedPeriod
    && option.selectedPeriod.discount
    || 0;

export const hasDiscount = (option) => getDiscount(option) > 0;
